<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <div class="w-full grid lg:grid-cols-[2fr_1fr] md:grid-cols-2 grid-cols-1 gap-4 items-start">
        <p-card>
            <div class="w-full flex flex-col gap-4">
                <h1 class="text-2xl font-bold">Editar/Incluir CFOP</h1>

                <div class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end">
                    <app-input
                        id="descricao"
                        label="Descrição"
                        formControlName="Descricao"
                        class="sm:col-span-12"
                    ></app-input>

                    <div class="sm:col-span-12 flex flex-col gap-1">
                        <label for="aplicacao" class="font-bold text-black"
                            >Aplicação</label
                        >
                        <textarea
                            id="aplicacao"
                            formControlName="Aplicacao"
                            pInputTextarea
                            rows="4"
                            class="w-full bg-white border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-300 rounded-lg"
                        ></textarea>
                    </div>

                    <app-input
                        id="cfop"
                        type="number"
                        label="CFOP"
                        formControlName="Cfop"
                        class="sm:col-span-4"
                    ></app-input>

                    <app-select
                        [icon]="true"
                        label="Origem"
                        formControlName="Origem"
                        [options]="origem"
                        class="sm:col-span-4"
                    ></app-select>

                    <app-select
                        [icon]="true"
                        label="Tipo Operação"
                        formControlName="TipoOperacao"
                        [options]="tipoOperacao"
                        class="sm:col-span-4"
                    ></app-select>
                </div>

                <div
                    class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
                >
                    <app-button
                        variant="danger"
                        (click)="cancelar()"
                        class="md:max-w-45 w-full"
                        >Cancelar</app-button
                    >

                    <app-button
                        variant="success"
                        (click)="processarFormulario()"
                        class="md:max-w-45 w-full"
                        >Salvar</app-button
                    >
                </div>
            </div>
        </p-card>

        <p-card>
            <div class="w-full grid md:grid-cols-2 grid-cols-1 gap-4">
                <app-toggle-button
                    label="Permitir Crédito Ipi"
                    formControlName="PermiteCreditoIpi"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Permitir Crédito Icms"
                    formControlName="PermiteCreditoIcms"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Permitir Crédito Cofins"
                    formControlName="PermiteCreditoCofins"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Permitir Crédito Pis"
                    formControlName="PermiteCreditoPis"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Gera Diferencial Aliq"
                    formControlName="GeraDiferencialAliq"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Ind Nfe"
                    formControlName="IndNfe"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Ind Transporte"
                    formControlName="IndTransporte"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Ind Comunicação"
                    formControlName="IndComunicacao"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Ind Devolução"
                    formControlName="IndDevolucao"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Ind Combustível"
                    formControlName="IndCombustivel"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Ind Remessa"
                    formControlName="IndRemessa"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>

                <app-toggle-button
                    label="Ind Retorno"
                    formControlName="IndRetorno"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>
                
                <app-toggle-button
                    label="Ind Anulação"
                    formControlName="IndAnulacao"
                    [onLabel]="onLabel"
                    [offLabel]="offLabel"
                ></app-toggle-button>
            </div>
        </p-card>
    </div>
</div>
